import { CollectionUUID, Recipe } from '@library/menu-service'

import { useBasketRecipes } from 'hooks/basket/useBasketRecipes'
import { useCollectionEnrichedRecipeSets } from 'routes/Menu/domains/menu/useCollectionEnrichedRecipeSets'

const compareCoreRecipeIds = (a: Recipe, b: Recipe) =>
  parseInt(a.coreId, 10) - parseInt(b.coreId, 10)

const renderRecipeName = (recipe: Recipe) =>
  [
    recipe.name,
    recipe.dietaryClaims.some((claim) => claim.slug === 'vegetarian' || claim.slug === 'vegan')
      ? '(V)'
      : undefined,
  ]
    .filter((part) => Boolean(part))
    .join(' ')

export const useRecipeOptions = (collectionId: CollectionUUID, mainRecipe: Recipe) => {
  const recipeSets = useCollectionEnrichedRecipeSets(collectionId)

  const { basketHasRecipe } = useBasketRecipes()

  // recipeId passed into this function can be either the main recipe in a recipe set or an option
  const collectionRecipeSet = recipeSets.find((recipeSet) => recipeSet.recipeIds.has(mainRecipe.id))
  if (!collectionRecipeSet) {
    // eslint-disable-next-line no-console
    console.error('Recipe is not in the collection')

    return []
  }

  const baseRecipeAndOptions = [collectionRecipeSet.baseRecipe, ...collectionRecipeSet.options]
  const orderedOptions = [
    mainRecipe,
    ...baseRecipeAndOptions.filter((recipe) => recipe.id !== mainRecipe.id),
  ].sort(compareCoreRecipeIds)

  return orderedOptions.map((recipe) => ({
    recipe,
    recipeId: recipe.coreId,
    recipeName: renderRecipeName(recipe),
    isChecked: mainRecipe.id === recipe.id,
    isOutOfStock: !recipe.isAvailable && !basketHasRecipe(recipe.coreId),
    surcharge: recipe.surcharge ? recipe.surcharge.pricePerPortion / 100 : null,
  }))
}
